import { differenceInDays } from "date-fns";
import { fetchReport, fetchReportSandbox, fetchReportV2, fetchSummaryAggrate } from "../../services/v2.api";
import { setAccountSettingThunk, setUserThunk } from "./Account/creator";
import { SET_DASHBOARD_VIEW, USER_ACCESS_DETAILS, USER_AUTHENTICATED, USER_LOGGED_OUT } from "./type";
import { clientAuthContext } from "../../libs/auth.context";

export const setUserAuthenticated = () => ({ type: USER_AUTHENTICATED });
export const setUserAccessDetails = (user) => ({ type: USER_ACCESS_DETAILS, payload: user });

export function resetStore() {
    clientAuthContext.resetToken();
    return {
      type: USER_LOGGED_OUT,
    };
  }

export function setRequiredDataThunk({
    accountId
  }) {
    return (dispatch) => {
      dispatch(setAccountSettingThunk({ accountId }, true)); // 1);
      dispatch(setUserThunk(true)); // 1);
    };
  }

export function setDashboardData({
    accountId, lId, startDate, endDate, activeSelection, isCustomDate,
  }) {
    return (dispatch) => {
      dispatch({ type: SET_DASHBOARD_VIEW, payload: { startDate, endDate, activeSelection, isCustomDate, isLoading: true }});
      fetchReportV2({ accountId, lId, range: { startDate, endDate } }).then((res) => {
        const { resultArr } = res;
        console.log('RESULT _', resultArr);
        const result = [];
        let pointer = 0;
        resultArr.sort((a, b) => a.createdAt - b.createdAt);
        const firstItem = Math.min(new Date(resultArr?.[0]?._id || startDate).getTime(), startDate);
        const days = differenceInDays(endDate, firstItem);
        console.log('DAYS,', days);
        
        // for (let index = 0; index <= days; index++) {
        //   const day = format(add(firstItem, { days: index }), "yyyy-L-d");
        //   if (resultArr?.[pointer]?._id === day) {
        //     result[index] = resultArr[pointer];
        //     pointer += 1;
        //   } else {
        //     result[index] = { _id: day };
        //   }
        // }
        // console.log('DAYS,', result);
        dispatch({ type: SET_DASHBOARD_VIEW, payload: { resultArr, isLoading: false }});
      }).catch((err) => {
        console.log(err);
        
        dispatch({ type: SET_DASHBOARD_VIEW, payload: { isLoading: false }})
      })
      fetchSummaryAggrate({ accountId, lId, range: { startDate, endDate } }).then((res) => {
        const { stats } = res;
        if (stats) {
          dispatch({ type: SET_DASHBOARD_VIEW, payload: { stats, isLoading: false }});
        } else {
          fetchReportSandbox({ accountId, lId, range: { startDate, endDate } }).then((res) => {
            const { resultArr, stats } = res;
            const payload = { stats, isLoading: false };
            if (resultArr?.length) {
              resultArr.sort((a, b) => a._id.localeCompare(b._id, undefined, { sensitivity: 'base' }));
              payload.resultArr = resultArr;
            }
            dispatch({ type: SET_DASHBOARD_VIEW, payload });
          }).catch((err) => {
            console.log(err);
            dispatch({ type: SET_DASHBOARD_VIEW, payload: { isLoading: false }})
          })
        }
      })
    };
  }